//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionEvaPN from './dosificacionEvaPN'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionEvaPN />
            </div>
        );
    }

}
export default Index;